import { jsx as _jsx } from "react/jsx-runtime";
import { Layout } from 'antd';
import clsx from 'clsx';
import styles from './style.module.less';
const Screen = ({ intro = false, children }) => (_jsx(Layout, { className: clsx(styles.screen, intro ? styles.intro : null), children: children }));
export default Screen;
